import Marquee from "react-fast-marquee";
import { useI18n } from "@/context/Language";

export const EditorialMarquee = () => {
  const { t } = useI18n();
  return (
    <section className="relative py-6 overflow-hidden bg-sand-2 border-y border-border-soft">
      <Marquee speed={28} gradient={false} autoFill>
        {t.marquee.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 text-sm uppercase tracking-[0.24em] text-ink/45">{item}</span>
            <span className="text-ink/20">·</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
